import React, { useEffect, useState } from "react";
import AxiosInstance from "../Home/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiEdit, FiTrash } from "react-icons/fi";
import TrainerHeader from "./TrainerHeader";
import Footer from "../Home/Footer";
import profile from "../Home/Profile.png";
import "./TrainerDetails.css";
import "./trainerPortal.css";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useResizeColumns,
  usePagination,
} from "react-table";

export default function TrainerDetails() {
  const [trainer, setTrainer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editedTrainer, setEditedTrainer] = useState({});
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(null);
  const [addressTypeOptions, setAddressTypeOptions] = useState([]);
  const [address, setAddress] = useState([]);
  const [education, setEducation] = useState([]);
  const [editingAddress, setEditingAddress] = useState(null);
  const [editedAddress, setEditedAddress] = useState(null);
  const [addressFilter, setAddressFilter] = useState("");
  const [editAddressSearch, setEditAddressSearch] = useState("");
  const [editSuggestions, setEditSuggestions] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [editingEducation, setEditingEducation] = useState(null);
  const [editedEducation, setEditedEducation] = useState(null);
  const [educationFilter, setEducationFilter] = useState("");
  const [certification, setCertification] = useState([]);
  const [certificationOptions, setCertificationOptions] = useState([]);
  const [editingCertification, setEditingCertification] = useState(null);
  const [editedCertification, setEditedCertification] = useState(null);
  const [certificationFilter, setCertificationFilter] = useState("");
  const [workExperiences, setWorkExperiences] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [editingWorkExperience, setEditingWorkExperience] = useState(null);
  const [editedWorkExperience, setEditedWorkExperience] = useState(null);
  const [workExperienceFilter, setWorkExperienceFilter] = useState("");
  const [achievement, setAchievement] = useState([]);
  const [editingAchievement, setEditingAchievement] = useState(null);
  const [editedAchievement, setEditedAchievement] = useState(null);
  const [achievementFilter, setAchievementFilter] = useState("");
  const [socialLink, setSocialLink] = useState([]);
  const [editingSocialLink, setEditingSocialLink] = useState(null);
  const [editedSocialLink, setEditedSocialLink] = useState(null);
  const [socialLinkFilter, setSocialLinkFilter] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");

    if (trainerId) {
      AxiosInstance.get(`companies/trainer-details/${trainerId}`)
        .then((response) => {
          setTrainer(response.data);
          setEditedTrainer(response.data);
        })
        .catch((error) => {
          console.error("Error fetching trainer details:", error);
        });
    }
  }, []);

  const openModal = () => {
    setEditedTrainer(trainer);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    setEditedTrainer({ ...editedTrainer, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const trainerId = localStorage.getItem("trainerId");
    const formData = new FormData();

    formData.append("first_name", editedTrainer.first_name);
    formData.append("last_name", editedTrainer.last_name);
    formData.append("alias_name", editedTrainer.alias_name);
    formData.append("email", editedTrainer.email);
    formData.append("mobile_no", editedTrainer.mobile_no);
    formData.append("gender", editedTrainer.gender || "");
    formData.append("dob", editedTrainer.dob || "");
    formData.append("status", editedTrainer.status || "");
    formData.append("about", editedTrainer.about || "");

    if (editedTrainer.image_file) {
      formData.append("image_path", editedTrainer.image_file);
    }

    AxiosInstance.put(`companies/trainer/update/${trainerId}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setTrainer(response.data);
        closeModal();
      })
      .catch((error) => {
        console.error("Error updating trainer:", error);
      });
  };

  useEffect(() => {
    const fetchStatesAndCountries = async () => {
      try {
        const countriesResponse = await AxiosInstance.get(
          "companies/countries/"
        );
        setCountries(countriesResponse.data || []);

        if (country) {
          const statesResponse = await AxiosInstance.get(
            `companies/states/${country}/`
          );
          setStates(statesResponse.data || []);
        }
      } catch (error) {
        console.error("Error fetching states and countries:", error);
      }
    };

    fetchStatesAndCountries();
  }, [country]);

  useEffect(() => {
    const fetchAddressTypes = async () => {
      try {
        const response = await AxiosInstance.get("companies/address/types/");
        if (response.status === 200) {
          setAddressTypeOptions(response.data);
        } else {
          console.error("Failed to fetch address types");
        }
      } catch (error) {
        console.error("Error fetching address types:", error);
      }
    };

    fetchAddressTypes();
  }, []);

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("trainer ID is missing. Please log in.");
      return;
    }

    const fetchAddress = async () => {
      try {
        const addressResponse = await AxiosInstance.get(
          `companies/trainer/addresses/${trainerId}/`
        );
        setAddress(addressResponse.data || []);
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    };

    fetchAddress();
  }, []);

  const handleAdd = (section) => {
    navigate(`/trainer-${section}`);
  };

  useEffect(() => {
    if (!editAddressSearch) {
      setEditSuggestions([]);
      return;
    }

    const timeout = setTimeout(async () => {
      try {
        const res = await AxiosInstance.get("companies/get-address/", {
          params: { address: editAddressSearch },
        });
        setEditSuggestions(res.data.suggestions || []);
      } catch (err) {
        console.error("Edit autocomplete failed", err);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [editAddressSearch]);

  const handleEditAddressSelect = async (placeId) => {
    setEditSuggestions([]);
    setEditAddressSearch("");

    try {
      const res = await AxiosInstance.get("companies/get-address-details/", {
        params: { placeId },
      });

      const data = res.data;

      const matchedCountry = countries.find(
        (c) => c.country_name === data.country
      );
      const matchedState = states.find((s) => s.state_name === data.state);

      setEditedAddress((prev) => ({
        ...prev,
        address_line1: data.addressLine1 || "",
        address_line2: data.addressLine2 || "",
        city: data.city || "",
        zip_code: data.postalCode || "",
        country: matchedCountry ? matchedCountry.country_id : "",
        state: matchedState ? matchedState.state_id : "",
      }));
    } catch (err) {
      console.error("Error fetching address details", err);
    }
  };

  const handleEditAddress = (index) => {
    const addressToEdit = address[index];

    setEditingAddress(addressToEdit);
    setEditedAddress({
      ...addressToEdit,
      country: addressToEdit.country?.country_id || "",
      state: addressToEdit.state?.state_id || "",
      address_type: addressToEdit.address_type?.address_type_id || "",
    });

    setCountry(addressToEdit.country?.country_id || "");
  };

  const handleAddressInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAddress({
      ...editedAddress,
      [name]: value,
    });
  };

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    setCountry(countryId);
    setEditedAddress({ ...editedAddress, country: countryId });
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setEditedAddress({ ...editedAddress, state: stateId });
  };

  const handleAddressTypeChange = (e) => {
    const typeId = e.target.value;
    setEditedAddress({ ...editedAddress, address_type: typeId });
  };

  const handleSaveAddress = async () => {
    if (!editedAddress?.address_id) {
      console.error("Address ID is missing.");
      return;
    }

    const payload = {
      address_line1: editedAddress.address_line1,
      address_line2: editedAddress.address_line2,
      city: editedAddress.city,
      zip_code: editedAddress.zip_code,
      state: editedAddress.state,
      country: editedAddress.country,
      address_type: editedAddress.address_type,
    };

    try {
      await AxiosInstance.put(
        `companies/user/address/${editedAddress.address_id}/`,
        payload
      );

      const updatedAddresses = address.map((addr) =>
        addr.address_id === editedAddress.address_id
          ? {
              ...addr,
              ...payload,
              country:
                countries.find((c) => c.country_id === editedAddress.country) ||
                {},
              state:
                states.find((s) => s.state_id === editedAddress.state) || {},
              address_type:
                addressTypeOptions.find(
                  (a) => a.address_type_id === editedAddress.address_type
                ) || {},
            }
          : addr
      );

      setAddress(updatedAddresses);
      setEditingAddress(null);
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  const handleRemoveAddress = async (index) => {
    const addressIdToRemove = address[index]?.address_id;

    if (!addressIdToRemove) {
      console.error("Address ID is missing.");
      return;
    }

    const isConfirmed = window.confirm(
      "Are you sure you want to remove this address?"
    );
    if (!isConfirmed) {
      console.log("Address removal canceled.");
      return;
    }

    try {
      await AxiosInstance.delete(
        `companies/user-address/${addressIdToRemove}/`
      );

      const updatedAddresses = [...address];
      updatedAddresses.splice(index, 1);
      setAddress(updatedAddresses);

      console.log("Address removed successfully.");
    } catch (error) {
      console.error("Error removing address:", error);
    }
  };

  const addressColumns = React.useMemo(
    () => [
      { Header: "Address Line 1", accessor: "address_line1" },
      { Header: "Address Line 2", accessor: "address_line2" },
      { Header: "City", accessor: "city" },
      { Header: "State", accessor: (d) => d.state?.state_name || "" },
      { Header: "Country", accessor: (d) => d.country?.country_name || "" },
      { Header: "Zip Code", accessor: "zip_code" },
      { Header: "Address Type", accessor: (d) => d.address_type?.address_type || ""},
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditAddress(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveAddress(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [address]
  );

  const addressTableInstance = useTable(
    {
      columns: addressColumns,
      data: address,
      initialState: { globalFilter: addressFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useResizeColumns
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex },
  } = addressTableInstance;

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("Trainer ID is missing. Please log in.");
      return;
    }

    const fetchEducation = async () => {
      try {
        const educationResponse = await AxiosInstance.get(
          `companies/trainer/educations/${trainerId}/`
        );
        console.log("Education Response:", educationResponse.data);
        setEducation(educationResponse.data || []);
      } catch (error) {
        console.error("Error fetching education:", error);
      }
    };

    fetchEducation();
  }, []);

  // Fetch education options from the API, including qualifications
  useEffect(() => {
    const fetchEducationOptions = async () => {
      try {
        const response = await AxiosInstance.get("companies/educations/");
        if (response.status === 200) {
          console.log("Fetched education options:", response.data);
          setEducationOptions(response.data);

          const qualifications = response.data.map((education) => ({
            education_id: education.education_id,
            qualification: education.qualification,
          }));
          setQualificationOptions(qualifications);
        } else {
          alert("Failed to fetch education options. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching education options:", error);
        alert("Failed to fetch education options. Please try again later.");
      }
    };

    fetchEducationOptions();
  }, []);

  // Handle qualification change
  const handleQualificationChange = (e) => {
    const selectedEducationId = parseInt(e.target.value, 10);

    setEditedEducation((prev) => ({
      ...prev,
      education: selectedEducationId,
    }));
  };

  // Handle edit of education
  const handleEditEducation = (index) => {
    console.log("Edit clicked on index:", index);

    const educationToEdit = education[index];

    if (!educationToEdit?.user_education_id) {
      console.error("Invalid education record selected for editing.");
      return;
    }

    setEditingEducation(educationToEdit);
    setEditedEducation({
      ...educationToEdit,
      education: educationToEdit.education,
    });
  };

  // Handle input change in education fields
  const handleEducationInputChange = (e) => {
    const { name, value } = e.target;
    setEditedEducation({
      ...editedEducation,
      [name]: value,
    });
  };

  // Handle save of education data
  const handleSaveEducation = async () => {
    if (!editedEducation?.user_education_id) {
      console.error("Education ID is missing.");
      return;
    }

    const payload = {
      education:
        typeof editedEducation.education === "object"
          ? editedEducation.education.education_id
          : editedEducation.education,
      university: editedEducation.university,
      college_name: editedEducation.college_name,
      specialization: editedEducation.specialization,
      year_of_starting: editedEducation.year_of_starting,
      year_of_passing: editedEducation.year_of_passing,
      percentage_or_cgpa: editedEducation.percentage_or_cgpa,
    };

    try {
      const response = await AxiosInstance.put(
        `companies/user-educations/${editedEducation.user_education_id}/`,
        payload
      );

      const updatedEducations = education.map((item) =>
        item.user_education_id === editedEducation.user_education_id
          ? response.data
          : item
      );

      setEducation(updatedEducations);
      setEditingEducation(null);
    } catch (error) {
      console.error("Error saving education:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
      }
    }
  };

  const handleRemoveEducation = async (index) => {
    const educationId = education[index]?.user_education_id;
    if (!educationId) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this education?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(`companies/user-education/${educationId}/`);
      const updatedEducation = education.filter(
        (edu) => edu.user_education_id !== educationId
      );
      setEducation(updatedEducation);
    } catch (error) {
      console.error("Error removing education:", error);
    }
  };

  const educationColumns = React.useMemo(
    () => [
      { Header: "University Name", accessor: "university" },
      { Header: "College Name", accessor: "college_name" },
      {
        Header: "Qualification",
        accessor: (d) =>
          typeof d.education === "object"
            ? d.education.qualification
            : qualificationOptions.find((q) => q.education_id === d.education)
                ?.qualification || "",
      },
      { Header: "Specialization", accessor: "specialization" },
      { Header: "Year Of Starting", accessor: "year_of_starting" },
      { Header: "Year Of Passing", accessor: "year_of_passing" },
      { Header: "Percentage/CGPA", accessor: "percentage_or_cgpa" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditEducation(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleRemoveEducation(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [education]
  );

  const educationTableInstance = useTable(
    {
      columns: educationColumns,
      data: education || [],
      initialState: { globalFilter: educationFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getEducationTableProps,
    getTableBodyProps: getEducationTableBodyProps,
    headerGroups: educationHeaderGroups,
    prepareRow: prepareEducationRow,
    page: educationPage,
    state: { pageIndex: educationPageIndex },
    gotoPage: gotoEducationPage,
    pageCount: educationPageCount,
    nextPage: nextEducationPage,
    previousPage: previousEducationPage,
    canNextPage: canNextEducationPage,
    canPreviousPage: canPreviousEducationPage,
    setPageSize: setEducationPageSize,
    setGlobalFilter: setEducationGlobalFilter,
  } = educationTableInstance;

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");

    AxiosInstance.get(`companies/trainer/certifications/${trainerId}/`)
      .then((res) => setCertification(res.data || []))
      .catch((err) => console.error("Error loading certifications:", err));

    AxiosInstance.get(`companies/certifications/`)
      .then((res) => setCertificationOptions(res.data || []))
      .catch((err) =>
        console.error("Error loading certification options:", err)
      );
  }, []);

  const handleEditCertification = (index) => {
    const selected = certification[index];
    setEditingCertification(selected);
    setEditedCertification({
      ...selected,
      certification:
        selected.certification?.certification_id || selected.certification,
    });
  };

  const handleCertificationChange = (e) => {
    const { name, value } = e.target;

    setEditedCertification((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "certification") {
      const selectedOption = certificationOptions.find(
        (opt) => String(opt.certification_id) === value
      );

      setEditedCertification((prev) => ({
        ...prev,
        certification_name: selectedOption?.certification_name || "",
      }));
    }
  };

  const handleSaveCertification = async () => {
    if (!editedCertification?.user_certification_id) return;

    const payload = {
      ...editedCertification,
      certification: editedCertification.certification,
    };

    try {
      const response = await AxiosInstance.put(
        `companies/user-certifications/${editedCertification.user_certification_id}/`,
        payload
      );

      const updatedItem = {
        ...response.data,
        certification_name: editedCertification.certification_name, 
      };

      const updatedList = certification.map((item) =>
        item.user_certification_id === updatedItem.user_certification_id
          ? updatedItem
          : item
      );

      setCertification(updatedList);
      setEditingCertification(null);
    } catch (error) {
      console.error("Error updating certification:", error);
    }
  };

  const handleDeleteCertification = async (index) => {
    const id = certification[index]?.user_certification_id;
    if (!id) return;

    if (!window.confirm("Are you sure you want to remove this certification?"))
      return;

    try {
      await AxiosInstance.delete(`companies/user-certification/${id}/`);
      setCertification((prev) =>
        prev.filter((cert) => cert.user_certification_id !== id)
      );
    } catch (err) {
      console.error("Failed to delete certification:", err);
    }
  };

  const certificationColumns = React.useMemo(
    () => [
      { Header: "Name", accessor: "certification_name" },
      { Header: "Authority", accessor: "issue_authority" },
      { Header: "Issue Date", accessor: "issue_date" },
      { Header: "Expiry Date", accessor: "expiry_date" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditCertification(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteCertification(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [certification]
  );

  const certificationTableInstance = useTable(
    {
      columns: certificationColumns,
      data: certification || [],
      initialState: { globalFilter: certificationFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getCertificationTableProps,
    getTableBodyProps: getCertificationTableBodyProps,
    headerGroups: certificationHeaderGroups,
    prepareRow: prepareCertificationRow,
    page: certificationPage,
    state: { pageIndex: certificationPageIndex },
    gotoPage: gotoCertificationPage,
    pageCount: certificationPageCount,
    nextPage: nextCertificationPage,
    previousPage: previousCertificationPage,
    canNextPage: canNextCertificationPage,
    canPreviousPage: canPreviousCertificationPage,
    setPageSize: setCertificationPageSize,
    setGlobalFilter: setCertificationGlobalFilter,
  } = certificationTableInstance;

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");

    // Fetch assigned workExperiences
    AxiosInstance.get(`companies/trainer/work-experiences/${trainerId}/`)
      .then((res) => setWorkExperiences(res.data || []))
      .catch((err) => console.error("Error loading work experiences:", err));

    // Fetch master role options
    AxiosInstance.get(`companies/roles/`)
      .then((res) => setRoleOptions(res.data || []))
      .catch((err) => console.error("Error loading role options:", err));
  }, []);

  const handleEditWorkExperience = (index) => {
    const selected = workExperiences[index];
    setEditingWorkExperience(selected);
    setEditedWorkExperience({
      ...selected,
      role: selected.role?.role_id || selected.role,
    });
  };

  const handleWorkExperienceChange = (e) => {
    setEditedWorkExperience({
      ...editedWorkExperience,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveWorkExperience = async () => {
    if (!editedWorkExperience?.experience_id) return;

    const payload = {
      role: editedWorkExperience.role,
      company_name: editedWorkExperience.company_name,
      experience: editedWorkExperience.experience,
      trainer: editedWorkExperience.trainer,
    };

    try {
      const response = await AxiosInstance.put(
        `companies/work/experiences/${editedWorkExperience.experience_id}/`,
        payload
      );

      const updatedList = workExperiences.map((item) =>
        item.experience_id === editedWorkExperience.experience_id
          ? response.data
          : item
      );

      setWorkExperiences(updatedList);
      setEditingWorkExperience(null);
    } catch (error) {
      console.error("Error updating work experience:", error);
    }
  };

  const handleDeleteWorkExperience = async (index) => {
    const id = workExperiences[index]?.experience_id;
    if (!id) return;

    if (
      !window.confirm("Are you sure you want to remove this work experience?")
    )
      return;

    try {
      await AxiosInstance.delete(`companies/work-experience/${id}/`);
      setWorkExperiences((prev) =>
        prev.filter((exp) => exp.experience_id !== id)
      );
    } catch (err) {
      console.error("Failed to delete work experience:", err);
    }
  };

  const workExperienceColumns = React.useMemo(
    () => [
      { Header: "Company Name", accessor: "company_name", resizable: true },
      {
        Header: "Designation",
        accessor: (d) =>
          typeof d.role === "object"
            ? d.role.role
            : roleOptions.find((r) => r.role_id === d.role)?.role,
        resizable: true,
      },
      { Header: "Experience", accessor: "experience", resizable: true },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditWorkExperience(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteWorkExperience(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [workExperiences]
  );

  const workExperienceTableInstance = useTable(
    {
      columns: workExperienceColumns,
      data: workExperiences || [],
      initialState: { globalFilter: workExperienceFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getWorkExperienceTableProps,
    getTableBodyProps: getWorkExperienceTableBodyProps,
    headerGroups: workExperienceHeaderGroups,
    prepareRow: prepareWorkExperienceRow,
    page: workExperiencePage,
    state: { pageIndex: workExperiencePageIndex },
    gotoPage: gotoWorkExperiencePage,
    pageCount: workExperiencePageCount,
    nextPage: nextWorkExperiencePage,
    previousPage: previousWorkExperiencePage,
    canNextPage: canNextWorkExperiencePage,
    canPreviousPage: canPreviousWorkExperiencePage,
    setPageSize: setWorkExperiencePageSize,
    setGlobalFilter: setWorkExperienceGlobalFilter,
  } = workExperienceTableInstance;

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("Trainer ID is missing. Please log in.");
      return;
    }

    const fetchAchievements = async () => {
      try {
        const achievementResponse = await AxiosInstance.get(
          `companies/trainer/achievements/${trainerId}/`
        );
        console.log("Achievement Response:", achievementResponse.data);
        setAchievement(achievementResponse.data || []);
      } catch (error) {
        console.error("Error fetching achievement:", error);
      }
    };

    fetchAchievements();
  }, []);

  const achievementColumns = React.useMemo(
    () => [
      { Header: "Title", accessor: "title" },
      { Header: "Description", accessor: "description" },
      { Header: "Achievement Date", accessor: "achievement_date" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleAchievementEditClick(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteAchievement(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [achievement]
  );

  const handleAchievementEditClick = (index) => {
    const selected = achievement[index];
    setEditingAchievement(selected);
    setEditedAchievement({
      ...selected,
      achievement: selected.achievement?.achievement_id || selected.achievement,
    });
  };

  const handleSaveAchievement = async () => {
    if (!editingAchievement || !editingAchievement.achievement_id) {
      console.error("No achievement selected for editing.");
      return;
    }

    try {
      const response = await AxiosInstance.put(
        `companies/user-achievements/${editingAchievement.achievement_id}/`,
        editingAchievement
      );

      if (response.status === 200) {
        console.log("Achievement updated:", response.data);

        // Update state with new achievement data
        const updatedAchievements = achievement.map((item) =>
          item.achievement_id === editingAchievement.achievement_id
            ? { ...item, ...response.data }
            : item
        );
        setAchievement(updatedAchievements);

        // Clear editing states
        setEditingAchievement(null);
        setEditedAchievement(null);
      } else {
        console.error("Failed to update achievement:", response);
      }
    } catch (error) {
      console.error("Error updating achievement:", error);
    }
  };

  const handleDeleteAchievement = async (index) => {
    const achievementId = achievement[index]?.achievement_id;
    if (!achievementId) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this achievement?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(
        `companies/user-achievement/${achievementId}/`
      );
      const updatedAchievement = achievement.filter(
        (link) => link.achievement_id !== achievementId
      );
      setAchievement(updatedAchievement);
    } catch (error) {
      console.error("Error removing achievement:", error);
    }
  };

  const achievementTableInstance = useTable(
    {
      columns: achievementColumns,
      data: achievement || [],
      initialState: { globalFilter: achievementFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getAchievementTableProps,
    getTableBodyProps: getAchievementTableBodyProps,
    headerGroups: achievementHeaderGroups,
    prepareRow: prepareAchievementRow,
    page: achievementPage,
    state: { pageIndex: achievementPageIndex },
    gotoPage: gotoAchievementPage,
    pageCount: achievementPageCount,
    nextPage: nextAchievementPage,
    previousPage: previousAchievementPage,
    canNextPage: canNextAchievementPage,
    canPreviousPage: canPreviousAchievementPage,
    setPageSize: setAchievementPageSize,
    setGlobalFilter: setAchievementGlobalFilter,
  } = achievementTableInstance;

  useEffect(() => {
    const trainerId = localStorage.getItem("trainerId");
    if (!trainerId) {
      alert("Trainer ID is missing. Please log in.");
      return;
    }

    const fetchSocialLink = async () => {
      try {
        const socialLinkResponse = await AxiosInstance.get(
          `companies/trainer/social_link/${trainerId}`
        );
        console.log("Socail Link Response:", socialLinkResponse.data);
        setSocialLink(socialLinkResponse.data || []);
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLink();
  }, []);

  const socialLinkColumns = React.useMemo(
    () => [
      { Header: "Platform", accessor: "platform" },
      { Header: "URL", accessor: "url" },
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => handleEditClick(row.index)}
            >
              <FiEdit />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => handleDeleteSocialLink(row.index)}
            >
              <FiTrash />
            </button>
          </div>
        ),
      },
    ],
    [socialLink]
  );

  const handleEditClick = (index) => {
    const selected = socialLink[index];
    setEditingSocialLink(selected);
    setEditedSocialLink({
      ...selected,
      socialLink: selected.socialLink?.social_link_id || selected.socialLink,
    });
  };

  const handleSaveSocialLink = async () => {
    if (!editingSocialLink || !editingSocialLink.social_link_id) {
      console.error("No social link selected for editing.");
      return;
    }

    try {
      const response = await AxiosInstance.put(
        `companies/user/social_link/${editingSocialLink.social_link_id}/`,
        editingSocialLink
      );

      if (response.status === 200) {
        console.log("Social link updated:", response.data);

        // Update the state with a new array reference
        const updatedLinks = socialLink.map((link) =>
          link.social_link_id === editingSocialLink.social_link_id
            ? { ...link, ...response.data }
            : link
        );
        setSocialLink(updatedLinks);

        // Clear editing state
        setEditingSocialLink(null);
        setEditedSocialLink(null);
      } else {
        console.error("Failed to update social link:", response);
      }
    } catch (error) {
      console.error("Error updating social link:", error);
    }
  };

  const handleDeleteSocialLink = async (index) => {
    const socialLinkId = socialLink[index]?.social_link_id;
    if (!socialLinkId) return;

    const confirmed = window.confirm(
      "Are you sure you want to remove this social link?"
    );
    if (!confirmed) return;

    try {
      await AxiosInstance.delete(`companies/user/social-link/${socialLinkId}`);
      const updatedSocialLink = socialLink.filter(
        (link) => link.social_link_id !== socialLinkId
      );
      setSocialLink(updatedSocialLink);
    } catch (error) {
      console.error("Error removing social link:", error);
    }
  };

  const socialLinkTableInstance = useTable(
    {
      columns: socialLinkColumns,
      data: socialLink || [],
      initialState: { globalFilter: socialLinkFilter, pageSize: 7 },
    },
    useGlobalFilter,
    useSortBy,
    useResizeColumns,
    usePagination
  );

  const {
    getTableProps: getSocialLinkTableProps,
    getTableBodyProps: getSocialLinkTableBodyProps,
    headerGroups: socialLinkHeaderGroups,
    prepareRow: prepareSocialLinkRow,
    page: socialLinkPage,
    state: { pageIndex: socialLinkPageIndex },
    gotoPage: gotoSocialLinkPage,
    pageCount: socialLinkPageCount,
    nextPage: nextSocialLinkPage,
    previousPage: previousSocialLinkPage,
    canNextPage: canNextSocialLinkPage,
    canPreviousPage: canPreviousSocialLinkPage,
    setPageSize: setSocialLinkPageSize,
    setGlobalFilter: setSocialLinkGlobalFilter,
  } = socialLinkTableInstance;

  if (!trainer) {
    return <div>Loading trainer details...</div>;
  }

  return (
    <div className="TrainerPage als-trainer-portal">
      <TrainerHeader />
      <div className="trainer-container py-4">
        <div className="mb-3">
          <button
            className="navigate-button btn btn-outline-primary d-flex align-items-center"
            onClick={() => navigate(-1)}
            style={{ gap: "6px" }}
          >
            <FiArrowLeft /> Back
          </button>
        </div>
        <h2 className="section-heading">Personal Details</h2>
        <div className="trainer-content">
          <div className="card-custom p-3">
            <div className="d-flex gap-4 flex-wrap">
              {/* Left: Profile Image */}
              <div>
                <img
                  src={
                    trainer.image_path
                      ? `${AxiosInstance.defaults.baseURL}/media/${trainer.image_path.replace(
                          /\\/g,
                          "/"
                        )}`
                      : profile
                  }
                  alt="Profile"
                  className="profile-image"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>

              {/* Right: Trainer Info */}
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between">
                  <p>
                    <strong>Name:</strong> {trainer.first_name}{" "}
                    {trainer.last_name}
                  </p>
                  <button
                    onClick={openModal}
                    className="btn btn-sm btn-outline-primary"
                  >
                    <FiEdit />
                  </button>
                </div>
                <p>
                  <strong>Alias Name:</strong> {trainer.alias_name || "N/A"}
                </p>
                <p>
                  <strong>Email:</strong> {trainer.email}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {trainer.mobile_no}
                </p>
                <p>
                  <strong>Date Of Birth:</strong>{" "}
                  {trainer.dob
                    ? new Date(trainer.dob).toLocaleDateString()
                    : "N/A"}
                </p>
                <p>
                  <strong>Gender:</strong> {trainer.gender}
                </p>
                <p>
                  <strong>Status:</strong> {trainer.status}
                </p>
              </div>
            </div>
            <div className="mt-4">
              <strong>About:</strong>
              {trainer.about ? (
                (() => {
                  const lines = trainer.about
                    .split("\n")
                    .map((line) => line.trim())
                    .filter((line) => line !== "");

                  const bulletLines = [];
                  const paragraphLines = [];
                  
                  lines.forEach((line) => {
                    if (/^[-*•]\s+/.test(line)) {
                      bulletLines.push(line.replace(/^[-*•]\s+/, "").trim());
                    } else {
                      paragraphLines.push(line);
                    }
                  });

                  return (
                    <>
                      {paragraphLines.map((line, index) => (
                        <p key={`para-${index}`}>{line}</p>
                      ))}

                      {bulletLines.length > 0 && (
                        <ul>
                          {bulletLines.map((line, index) => (
                            <li key={`bullet-${index}`}>{line}</li>
                          ))}
                        </ul>
                      )}
                    </>
                  );
                })()
              ) : (
                <p>No description provided.</p>
              )}
            </div>
          </div>
        </div>
        {/* Edit Modal */}
        {isModalOpen && (
          <div
            className="modal d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Profile</h5>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          name="first_name"
                          className="form-control"
                          value={editedTrainer.first_name || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          name="last_name"
                          className="form-control"
                          value={editedTrainer.last_name || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Alias Name</label>
                        <input
                          type="text"
                          name="alias_name"
                          className="form-control"
                          value={editedTrainer.alias_name || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={editedTrainer.email || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Mobile Number</label>
                        <input
                          type="text"
                          name="mobile_no"
                          className="form-control"
                          value={editedTrainer.mobile_no || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Gender</label>
                        <select
                          name="gender"
                          className="form-select"
                          value={editedTrainer.gender || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label">Date of Birth</label>
                        <input
                          type="date"
                          name="dob"
                          className="form-control"
                          value={editedTrainer.dob || ""}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Status</label>
                        <select
                          name="status"
                          className="form-control"
                          value={editedTrainer.status || ""}
                          onChange={handleChange}
                        >
                          <option value="">-- Select Status --</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">About</label>
                      <textarea
                        name="about"
                        className="form-control"
                        rows="4"
                        placeholder={`• Experienced in strength training\n• Certified personal trainer\nOR\nWrite a short paragraph about yourself`}
                        value={editedTrainer.about || ""}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Profile Image</label>
                      <input
                        type="file"
                        name="image"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) =>
                          setEditedTrainer({
                            ...editedTrainer,
                            image_file: e.target.files[0],
                          })
                        }
                      />
                    </div>
                  </form>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleSave}>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Address Section */}
        <h2 className="section-heading">Addresses</h2>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={addressFilter || ""}
              onChange={(e) => {
                setAddressFilter(e.target.value);
                setGlobalFilter(e.target.value);
              }}
              placeholder="Search addresses..."
            />
            <button className="add-button" onClick={() => handleAdd("address")}>
              Add
            </button>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getTableProps()}
            >
              <thead className="table-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {address.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No addresses found</td>
                  </tr>
                ) : (
                  page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination d-flex align-items-center gap-2 mt-3">
              <button
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                className="btn btn-sm btn-outline-primary"
              >
                Previous
              </button>
              <span>
                Page <strong>{pageIndex + 1}</strong> of{" "}
                <strong>{pageOptions.length}</strong>
              </span>
              <button
                onClick={() => nextPage()}
                disabled={!canNextPage}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>
          {editingAddress && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Address</h5>
                  </div>

                  <div className="modal-body">
                    <form>
                      <div className="mb-3 position-relative">
                        <label className="form-label">Search Address</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type address..."
                          value={editAddressSearch}
                          onChange={(e) => setEditAddressSearch(e.target.value)}
                        />
                        {editSuggestions.length > 0 && (
                          <ul
                            className="list-group position-absolute w-100"
                            style={{ zIndex: 999 }}
                          >
                            {editSuggestions.map((item, index) => (
                              <li
                                key={index}
                                className="list-group-item list-group-item-action"
                                onClick={() =>
                                  handleEditAddressSelect(item.place_id)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                {item.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Address Line 1</label>
                          <input
                            type="text"
                            name="address_line1"
                            className="form-control"
                            value={editedAddress?.address_line1 || ""}
                            onChange={handleAddressInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Address Line 2</label>
                          <input
                            type="text"
                            name="address_line2"
                            className="form-control"
                            value={editedAddress?.address_line2 || ""}
                            onChange={handleAddressInputChange}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">City</label>
                          <input
                            type="text"
                            name="city"
                            className="form-control"
                            value={editedAddress?.city || ""}
                            onChange={handleAddressInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Zip Code</label>
                          <input
                            type="text"
                            name="zip_code"
                            className="form-control"
                            value={editedAddress?.zip_code || ""}
                            onChange={handleAddressInputChange}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Country</label>
                          <select
                            name="country"
                            className="form-select"
                            value={editedAddress?.country || ""}
                            onChange={handleCountryChange}
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option
                                key={country.country_id}
                                value={country.country_id}
                              >
                                {country.country_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">State</label>
                          <select
                            name="state"
                            className="form-select"
                            value={editedAddress?.state || ""}
                            onChange={handleStateChange}
                            disabled={!editedAddress?.country}
                          >
                            <option value="">Select State</option>
                            {states.map((state) => (
                              <option
                                key={state.state_id}
                                value={state.state_id}
                              >
                                {state.state_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address Type</label>
                        <select
                          name="address_type"
                          className="form-select"
                          value={editedAddress?.address_type || ""}
                          onChange={handleAddressTypeChange}
                        >
                          <option value="">Select Address Type</option>
                          {addressTypeOptions.map((type) => (
                            <option
                              key={type.address_type_id}
                              value={type.address_type_id}
                            >
                              {type.address_type}
                            </option>
                          ))}
                        </select>
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingAddress(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveAddress}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Education Section */}
        <h2 className="section-heading">Educations</h2>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={educationFilter || ""}
              onChange={(e) => {
                setEducationFilter(e.target.value);
                setEducationGlobalFilter(e.target.value);
              }}
              placeholder="Search education..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("education")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getEducationTableProps()}
            >
              <thead className="table-light">
                {educationHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getEducationTableBodyProps()}>
                {education.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No educations found</td>
                  </tr>
                ) : (
                  educationPage.map((row) => {
                    prepareEducationRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination d-flex align-items-center gap-2 mt-3">
              <button
                onClick={() => previousEducationPage()}
                disabled={!canPreviousEducationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Previous
              </button>
              <span>
                Page <strong>{educationPageIndex + 1}</strong> of{" "}
                <strong>{educationTableInstance.pageOptions.length}</strong>
              </span>
              <button
                onClick={() => nextEducationPage()}
                disabled={!canNextEducationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>

          {/* Edit Education Modal */}
          {editingEducation && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Education</h5>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">University</label>
                          <input
                            type="text"
                            name="university"
                            className="form-control"
                            value={editedEducation?.university || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">College Name</label>
                          <input
                            type="text"
                            name="college_name"
                            className="form-control"
                            value={editedEducation?.college_name || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Qualification</label>
                          <select
                            name="education"
                            className="form-select"
                            value={editedEducation?.education || ""}
                            onChange={handleEducationInputChange}
                          >
                            <option value="">Select Qualification</option>
                            {qualificationOptions.map((option) => (
                              <option
                                key={option.education_id}
                                value={option.education_id}
                              >
                                {option.qualification}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Specialization</label>
                          <input
                            type="text"
                            name="specialization"
                            className="form-control"
                            value={editedEducation?.specialization || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Year of Starting</label>
                          <input
                            type="date"
                            name="year_of_starting"
                            className="form-control"
                            value={editedEducation?.year_of_starting || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Year of Passing</label>
                          <input
                            type="date"
                            name="year_of_passing"
                            className="form-control"
                            value={editedEducation?.year_of_passing || ""}
                            onChange={handleEducationInputChange}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Percentage / CGPA</label>
                        <input
                          type="number"
                          step="0.01"
                          name="percentage_or_cgpa"
                          className="form-control"
                          value={editedEducation?.percentage_or_cgpa || ""}
                          onChange={handleEducationInputChange}
                        />
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingEducation(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveEducation}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Certification Section */}
        <h2 className="section-heading">Certifications</h2>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={certificationFilter || ""}
              onChange={(e) => {
                setCertificationFilter(e.target.value);
                setCertificationGlobalFilter(e.target.value);
              }}
              placeholder="Search certifications..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("certification")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getCertificationTableProps()}
            >
              <thead className="table-light">
                {certificationHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getCertificationTableBodyProps()}>
                {certification.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No certifications found</td>
                  </tr>
                ) : (
                  certificationPage.map((row) => {
                    prepareCertificationRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination d-flex align-items-center gap-2 mt-3">
              <button
                onClick={() => previousCertificationPage()}
                disabled={!canPreviousCertificationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Previous
              </button>
              <span>
                Page <strong>{certificationPageIndex + 1}</strong> of{" "}
                <strong>{certificationTableInstance.pageOptions.length}</strong>
              </span>
              <button
                onClick={() => nextCertificationPage()}
                disabled={!canNextCertificationPage}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>

          {/* Edit Certification Modal */}
          {editingCertification && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Certification</h5>
                  </div>

                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label className="form-label">Certification</label>
                        <select
                          name="certification"
                          className="form-select"
                          value={editedCertification?.certification || ""}
                          onChange={handleCertificationChange}
                        >
                          <option value="">Select Certification</option>
                          {certificationOptions.map((cert) => (
                            <option
                              key={cert.certification_id}
                              value={cert.certification_id}
                            >
                              {cert.certification_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Issue Authority</label>
                        <input
                          type="text"
                          name="issue_authority"
                          className="form-control"
                          value={editedCertification?.issue_authority || ""}
                          onChange={(e) =>
                            setEditedCertification({
                              ...editedCertification,
                              issue_authority: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Issue Date</label>
                          <input
                            type="date"
                            name="issue_date"
                            className="form-control"
                            value={editedCertification?.issue_date || ""}
                            onChange={(e) =>
                              setEditedCertification({
                                ...editedCertification,
                                issue_date: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Expiry Date</label>
                          <input
                            type="date"
                            name="expiry_date"
                            className="form-control"
                            value={editedCertification?.expiry_date || ""}
                            onChange={(e) =>
                              setEditedCertification({
                                ...editedCertification,
                                expiry_date: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Certificate Path</label>
                        <input
                          type="text"
                          name="certificate_path"
                          className="form-control"
                          value={editedCertification?.certificate_path || ""}
                          onChange={(e) =>
                            setEditedCertification({
                              ...editedCertification,
                              certificate_path: e.target.value,
                            })
                          }
                        />
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingCertification(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveCertification}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Work Experience Section */}
        <h2 className="section-heading">Work Experiences</h2>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={workExperienceFilter || ""}
              onChange={(e) => {
                setWorkExperienceFilter(e.target.value);
                setWorkExperienceGlobalFilter(e.target.value);
              }}
              placeholder="Search work experiences..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("experience")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getWorkExperienceTableProps()}
            >
              <thead className="table-light">
                {workExperienceHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getWorkExperienceTableBodyProps()}>
                {workExperiences.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No work experiences found</td>
                  </tr>
                ) : (
                  workExperiencePage.map((row) => {
                    prepareWorkExperienceRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination d-flex align-items-center gap-2 mt-3">
              <button
                onClick={() => previousWorkExperiencePage()}
                disabled={!canPreviousWorkExperiencePage}
                className="btn btn-sm btn-outline-primary"
              >
                Previous
              </button>
              <span>
                Page <strong>{workExperiencePageIndex + 1}</strong> of{" "}
                <strong>
                  {workExperienceTableInstance.pageOptions.length}
                </strong>
              </span>
              <button
                onClick={() => nextWorkExperiencePage()}
                disabled={!canNextWorkExperiencePage}
                className="btn btn-sm btn-outline-primary"
              >
                Next
              </button>
            </div>
          </div>

          {/* Edit Work Experience Modal */}
          {editingWorkExperience && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            >
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Work Experience</h5>
                  </div>

                  <div className="modal-body">
                    <form>
                      <div className="mb-3">
                        <label className="form-label">Designation</label>
                        <select
                          name="role"
                          className="form-select"
                          value={editedWorkExperience?.role || ""}
                          onChange={handleWorkExperienceChange}
                        >
                          <option value="">Select role</option>
                          {roleOptions.map((role) => (
                            <option key={role.role_id} value={role.role_id}>
                              {role.role}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          name="company_name"
                          className="form-control"
                          value={editedWorkExperience?.company_name || ""}
                          onChange={(e) =>
                            setEditedWorkExperience({
                              ...editedWorkExperience,
                              company_name: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Experience</label>
                        <input
                          type="text"
                          name="experience"
                          className="form-control"
                          value={editedWorkExperience?.experience || ""}
                          onChange={(e) =>
                            setEditedWorkExperience({
                              ...editedWorkExperience,
                              experience: e.target.value,
                            })
                          }
                        />
                      </div>
                    </form>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingWorkExperience(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveWorkExperience}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Acievements Section */}
        <h3 className="section-heading">Achievements</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={achievementFilter || ""}
              onChange={(e) => {
                setAchievementFilter(e.target.value);
                setAchievementGlobalFilter(e.target.value);
              }}
              placeholder="Search achievement records..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("achievement")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getAchievementTableProps()}
            >
              <thead className="table-light">
                {achievementHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getAchievementTableBodyProps()}>
                {achievement.length === 0 ? (
                  <tr>
                    <td colSpan="8">No achievements found</td>
                  </tr>
                ) : (
                  achievementPage.map((row) => {
                    prepareAchievementRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination d-flex align-items-center gap-2 mt-3">
            <button
              onClick={() => previousAchievementPage()}
              disabled={!canPreviousAchievementPage}
              className="btn btn-sm btn-outline-primary"
            >
              Previous
            </button>
            <span>
              Page <strong>{achievementPageIndex + 1}</strong> of{" "}
              <strong>{achievementTableInstance.pageOptions.length}</strong>
            </span>
            <button
              onClick={() => nextAchievementPage()}
              disabled={!canNextAchievementPage}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>

          {editingAchievement && (
            <div
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1rem",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
              }}
            >
              <div className="container py-4">
                <div
                  className="card mx-auto shadow"
                  style={{ maxWidth: "480px" }}
                >
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Edit Achievement</h5>
                  </div>
                  <form className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Achievement Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingAchievement.title || ""}
                        onChange={(e) =>
                          setEditingAchievement({
                            ...editingAchievement,
                            title: e.target.value,
                          })
                        }
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingAchievement.description || ""}
                        onChange={(e) =>
                          setEditingAchievement({
                            ...editingAchievement,
                            description: e.target.value,
                          })
                        }
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="form-label">Achievement Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={editingAchievement.achievement_date || ""}
                        onChange={(e) =>
                          setEditingAchievement({
                            ...editingAchievement,
                            achievement_date: e.target.value,
                          })
                        }
                        required
                      />
                    </div>
                  </form>
                  <div className="card-footer d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingAchievement(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveAchievement}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* Social Link SECTION */}
        <h3 className="section-heading">Social Links</h3>
        <div className="card-custom">
          <div className="d-flex justify-content-between mb-3">
            <input
              type="text"
              className="form-control w-50"
              value={socialLinkFilter || ""}
              onChange={(e) => {
                setSocialLinkFilter(e.target.value);
                setSocialLinkGlobalFilter(e.target.value);
              }}
              placeholder="Search social Link records..."
            />
            <button
              className="add-button"
              onClick={() => handleAdd("social-Link")}
            >
              Add
            </button>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              {...getSocialLinkTableProps()}
            >
              <thead className="table-light">
                {socialLinkHeaderGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " ▼"
                              : " ▲"
                            : ""}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getSocialLinkTableBodyProps()}>
                {socialLink.length === 0 ? (
                  <tr>
                    <td colSpan="8">No social Links found</td>
                  </tr>
                ) : (
                  socialLinkPage.map((row) => {
                    prepareSocialLinkRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="pagination d-flex align-items-center gap-2 mt-3">
            <button
              onClick={() => previousSocialLinkPage()}
              disabled={!canPreviousSocialLinkPage}
              className="btn btn-sm btn-outline-primary"
            >
              Previous
            </button>
            <span>
              Page <strong>{socialLinkPageIndex + 1}</strong> of{" "}
              <strong>{socialLinkTableInstance.pageOptions.length}</strong>
            </span>
            <button
              onClick={() => nextSocialLinkPage()}
              disabled={!canNextSocialLinkPage}
              className="btn btn-sm btn-outline-primary"
            >
              Next
            </button>
          </div>

          {editingSocialLink && (
            <div
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "1rem",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 1050,
              }}
            >
              <div className="container py-4">
                <div
                  className="card mx-auto shadow"
                  style={{ maxWidth: "480px" }}
                >
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Edit Social Link</h5>
                  </div>
                  <form className="card-body">
                    <div className="mb-3">
                      <label className="form-label">Platform</label>
                      <input
                        type="text"
                        className="form-control"
                        value={editingSocialLink.platform || ""}
                        onChange={(e) =>
                          setEditingSocialLink({
                            ...editingSocialLink,
                            platform: e.target.value,
                          })
                        }
                        placeholder="e.g. LinkedIn, GitHub"
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="form-label">URL</label>
                      <input
                        type="url"
                        className="form-control"
                        value={editingSocialLink.url || ""}
                        onChange={(e) =>
                          setEditingSocialLink({
                            ...editingSocialLink,
                            url: e.target.value,
                          })
                        }
                        placeholder="https://your-link.com"
                        required
                      />
                    </div>
                  </form>
                  <div className="card-footer d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setEditingSocialLink(null)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleSaveSocialLink}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
